module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Ordini","NoOrdersFound":"Nessun ordine trovato"},"en":{"pageTitle":"Orders","NoOrdersFound":"No orders found"}}')
  delete Component.options._Ctor
}
